import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Typography, Tag } from 'antd'
import ReactHtmlParser from 'react-html-parser';
import { ConvertCustomerScheduleType, isValidDate, ConvertCustomerScheduleStatus, RenderPaymentMethods } from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import NumberFormat from 'react-number-format';

const { Paragraph } = Typography;
class CustomerScheduleDetail extends Component {

    constructor() {
        super();
        this.state = {
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    render() {
        var { visible, currentItem } = this.props;

        const payment = currentItem?.latest_customer_payment || {};
        const { payment_method, installment_months, monthly_payment } = payment;
        const isInstallment = ["tragoptainhakhoa", "tragoptainganhang"].includes(payment_method);

        const RowItem = ({ label, children }) => (
            <Descriptions.Item label={label}>
                {children || '-'}
            </Descriptions.Item>
        );

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi tiết lịch hẹn"
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : 700}
                    bodyStyle={{ padding: 16 }}
                >
                    {!visible ? null : (
                        <>
                            {/* ===== THÔNG TIN KHÁCH HÀNG ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin khách hàng</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Tên khách hàng">
                                    {currentItem?.customer_name}
                                </RowItem>

                                <RowItem label="Mã khách hàng">
                                    <Paragraph
                                        style={{ margin: 0 }}
                                        copyable={{
                                            text: currentItem?.customer_code,
                                            tooltips: false
                                        }}
                                    >
                                        <Tag color="blue">{currentItem?.customer_code}</Tag>
                                    </Paragraph>
                                </RowItem>

                                <RowItem label="Cơ sở khách hàng">
                                    {currentItem?.branch_name}
                                </RowItem>

                                <RowItem label="Cơ sở thực hiện">
                                    {currentItem?.branch_names}
                                </RowItem>
                            </Descriptions>

                            {/* ===== THÔNG TIN LỊCH HẸN ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin lịch hẹn</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Kiểu lịch hẹn">
                                    {ConvertCustomerScheduleType(currentItem?.name)}
                                </RowItem>

                                <RowItem label="Trạng thái">
                                    {ConvertCustomerScheduleStatus(currentItem?.status)}
                                </RowItem>

                                <RowItem label="Thời gian">
                                    {isValidDate(currentItem?.time)}
                                </RowItem>

                                <RowItem label={`Thời điểm ${currentItem?.name === 'GOILAI' ? 'gọi' : 'đến'}`}>
                                    {isValidDate(currentItem?.time_to)}
                                </RowItem>
                            </Descriptions>

                            {/* ===== THANH TOÁN ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thanh toán</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Hình thức thanh toán">
                                    <span>{RenderPaymentMethods(payment_method)}</span>

                                    {isInstallment && (
                                        <span style={{ marginLeft: 8, color: '#666', fontStyle: 'italic' }}>
                                            ({installment_months} tháng ·&nbsp;
                                            <NumberFormat
                                                value={monthly_payment}
                                                displayType="text"
                                                suffix="đ"
                                                thousandSeparator
                                            />
                                            /tháng)
                                        </span>
                                    )}
                                </RowItem>
                            </Descriptions>

                            {/* ===== NHÂN SỰ ===== */}
                            <Divider orientation="left" orientationMargin={0}>Nhân sự</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Bác sĩ thực hiện">
                                    {currentItem?.doctors}
                                </RowItem>

                                <RowItem label="Phụ tá">
                                    {currentItem?.assistants}
                                </RowItem>

                                <RowItem label="Người cập nhật">
                                    {currentItem?.updated_user}
                                </RowItem>
                            </Descriptions>

                            {/* ===== THÔNG TIN HỆ THỐNG ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin hệ thống</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Ngày tạo">
                                    {isValidDate(currentItem?.created_at)}
                                </RowItem>

                                <RowItem label="Người tạo">
                                    {currentItem?.created_user}
                                </RowItem>
                            </Descriptions>

                            {/* ===== GHI CHÚ ===== */}
                            <Divider orientation="left" orientationMargin={0}>Ghi chú</Divider>
                            <div
                                style={{
                                    padding: 12,
                                    background: '#fafafa',
                                    border: '1px solid #f0f0f0',
                                    borderRadius: 6,
                                    minHeight: 80
                                }}
                            >
                                {currentItem?.note
                                    ? ReactHtmlParser(currentItem.note)
                                    : <em style={{ color: '#999' }}>Không có ghi chú</em>}
                            </div>
                        </>
                    )}
                </Drawer>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerScheduleDetail' })(CustomerScheduleDetail));
